import React, { Component } from 'react';

class PlayerAvatar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            avatarSrc: "/img/dito_tran.png"
        }
    }

    componentDidMount() {
        this.checkAvatar();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.avatarValue !== this.props.avatarValue || prevProps.playerId !== this.props.playerId) {
            this.checkAvatar();
        }
    }

    checkAvatar = async () => {
        const { firebase, playerId, avatarValue } = this.props;

        if (avatarValue !== playerId) {
            this.setState({ avatarSrc: "/img/dito_tran.png" });
            return;
        }

        const cacheKey = `avatar_url_${playerId}`;
        const cachedData = localStorage.getItem(cacheKey);

        if (cachedData) {
            const { url, timestamp } = JSON.parse(cachedData);
            const now = new Date().getTime();
            // Cache valid for 24 hours
            if (now - timestamp < 24 * 60 * 60 * 1000) {
                this.setState({ avatarSrc: url });
                return;
            }
        }

        try {
            const url = await firebase.getStorage()
                .ref("avatar")
                .child(playerId)
                .getDownloadURL();
            
            this.setState({ avatarSrc: url });
            
            localStorage.setItem(cacheKey, JSON.stringify({
                url: url,
                timestamp: new Date().getTime()
            }));
        } catch (error) {
            this.setState({ avatarSrc: "/img/dito_tran.png" });
        }
    }

    render() {
        const { style, className } = this.props;
        return (
            <img 
                src={this.state.avatarSrc} 
                alt="avatar" 
                className={className}
                style={style || { width: '30px', height: '30px', borderRadius: '50%' }} 
            />
        );
    }
}

export default PlayerAvatar;
